import React, { useEffect, useState, useMemo, useCallback } from 'react'
import pt from 'prop-types'
import noop from 'lodash/noop'
import { FormattedMessage as Lang } from 'react-intl'
import set from 'lodash/set'
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import useReduxTable from '@/hooks/useReduxTable'
import { ACTION_LOG_TABLE } from '@/store/actions/actionLog'
import { getTableParameters } from '@/store/selectors/actionLog'
import useHtmlTitle from '@/hooks/useHtmlTitle'
import UsersIcons from '@/components/icons/users'
import DutyTable from '@/components/blocks/DutyTable'
import TextControl from '@/components/controls/TextControl'
import PageSidebar from '@/components/regions/sidebars/PageSidebar'
import ViewTree from '@/components/blocks/ViewTree'
import PortalTooltip from '@/components/blocks/PortalTooltip'
import HeaderIcons from '@/components/icons/header'
import {
  fields,
  exportOptions,
} from '@/constants/tablesConfig/actionLog'
import {
  COMPANY,
  GROUP,
  USER,
  ADMIN,
  TENANT,
} from '@/constants/viewTree'
import {
  Main,
  Content,
  ContainerDetails,
  HeaderDetails,
  IconWrapper,
  IconContainer,
  TitleDetails,
  ContentDeatils,
  RowDetails,
  TitleRow,
  ValueRow,
} from './styles'

const detailsConfig = {
  eventTime: 'Дата и время действия',
  appName: 'Приложение',
  objectType: 'Тип объекта',
  objectName: 'Индентификатор объекта',
  action: 'Действиее',
  oldValue: 'Старое значение измененного атрибута',
  newValue: 'Новое значение измененного атрибута',
  otherChanges: 'Другие изменения',
}

const AlarmsManager = ({
  data,
  tableData,
  loading,

  setEventTypes,
  setStatusTypes,
  requestAlarmManagerTable,
  intl,
  requestActionLogTable,
  tenants,
  admins,
  groups,
  users,
  selectedTenant,
  requestGetAllTenants,
  requestGetTenantGroups,
  requestGetAllUsers,
  requestGetAllAdminTenants,
  loggedInUser,
  requestActivitiLogFile,
  setSelectedElement,
  requestActivitiLogDictinory,
  dictionaries,
  setActivitiLogFilter,
  activitiLogFilterValue,
  dates,
  setDatesRange,
}) => {
  useHtmlTitle(intl.messages['menu.activityLog'])
  const [search, setSearch] = useState(null)
  const [toggledTenantPath, setToggledTenantPath] = useState({})
  const [showDetails, setShowDetails] = useState(false)
  const [selectedRow, setSelectedRow] = useState({})
  const userRoles = useMemo(() => get(loggedInUser, 'roles', {}), [loggedInUser])
  const [selectedNode, setSelectedNode] = useState({})
  const [filterDictinories, setFilterDictinories] = useState({})

  useEffect(() => {
    requestGetAllTenants()
  }, [requestGetAllTenants])

  useEffect(() => {
    if (selectedNode.type === ADMIN) {
      setFilterDictinories({
        ...dictionaries,
        fullName: (dictionaries.fullName || []).filter((user) => user.value === selectedNode.id),
      })
    } else {
      setFilterDictinories({})
    }
  }, [selectedNode, dictionaries])

  useEffect(() => {
    if (tenants.length) {
      setSelectedElement({tenantId: tenants[0].id})
      requestActionLogTable({tenantId: tenants[0].id})
      requestActivitiLogDictinory()
    }
  }, [requestActionLogTable, tenants, setSelectedElement, requestActivitiLogDictinory])

  const tableProps = useReduxTable(ACTION_LOG_TABLE, getTableParameters)

  const handleChange = useCallback((value) => {
    setSearch(value)
  }, [setSearch])
  
  const resetSearch = () => {
    setSearch('')
  }

  const typesToElement = useMemo(() => ({
    [GROUP]: groups,
    [ADMIN]: admins,
    [TENANT]: tenants,
    [USER]: users,
  }), [
    admins,
    groups,
    tenants,
    users,
  ])
  const tenantStructure = useMemo(() => {
    if (!tenants.length) {
      return []
    }
    const newStructure = tenants.map((element) => {
      const tenantAdmins = (typesToElement[ADMIN] || {})[element.id] || []
      const tenantGroups = (typesToElement[GROUP] || {})[element.id] || []
      let newTenantGroups = []
      if (Object.keys(tenantGroups).length > 0) {
        newTenantGroups = tenantGroups.map((group) => {
          const groupUsers = group.usersAmount ? (typesToElement[USER] || {})[`${group.tenantId}-${group.id}`] || [] : []

          return {
            ...group,
            children: groupUsers,
          }
        })
      }
      return {
        ...element,
        loading: !((tenantAdmins.length > 0 || newTenantGroups.length > 0)),
        children: [
          ...element.children,
          ...tenantAdmins,
          ...newTenantGroups,
        ],
      }
    })
    return newStructure.map((tenant) => {
      const pathsForTenant = toggledTenantPath[tenant.id] || []
      const updatedTenant = { ...tenant }
      pathsForTenant.map((path) => {
        set(updatedTenant, `${path}toggled.`, true)
        return path
      })
      return updatedTenant
    })
  },
  [
    tenants,
    typesToElement,
    toggledTenantPath,
  ])

  const requestFile = (payload) => {
    requestActivitiLogFile(payload)
  }

  

  const handleSelected = useCallback((node, event) => () => {
    if (event === 'toggle') {
      const tenantId = node.tenantId || node.id
      const nodePath = node.path
      const nodeToggledValue = node.toggled || false
      const newTenantToggledNode = (toggledTenantPath[tenantId] || []).filter(
        (element) => element !== nodePath,
      )
      if (!nodeToggledValue) {
        newTenantToggledNode.push(nodePath)
      }
      setToggledTenantPath({
        ...toggledTenantPath,
        [tenantId]: newTenantToggledNode,
      })
      if (node.type === COMPANY && !node.toggled) {
        requestGetAllAdminTenants(node.id)
        if (!userRoles.isSuperAdmin) {
          requestGetTenantGroups(node.id)
        }
      }
      if (node.type === GROUP && !node.toggled) {
        requestGetAllUsers({ tenantId: node.tenantId, groupId: node.id })
      }
    }
    if (event === 'click') {
      setSelectedNode(node)
      setActivitiLogFilter({
        action: [],
        eventType: [],
        fullName: [],
        appName: [],
      })
      if (node.type === GROUP) {
        setSelectedElement({groupId: node.id})
        requestActionLogTable({groupId: node.id})
        return
      }
      if (node.type === COMPANY) {
        setSelectedElement({tenantId: node.id})
        requestActionLogTable({tenantId: node.id})
        requestActivitiLogDictinory({tenantId: node.id})
      } else {
        setSelectedElement({userId: node.id})
        requestActionLogTable({userId: node.id})
        requestActivitiLogDictinory({userId: node.id, tenantId: node.tenantId})
      }
    }
  },[
    toggledTenantPath, 
    requestActionLogTable, 
    setSelectedElement, 
    requestGetAllAdminTenants,
    requestGetAllUsers,
    requestGetTenantGroups,
    userRoles.isSuperAdmin,
    requestActivitiLogDictinory,
    setActivitiLogFilter,
  ])

  const handleFilterColumn = (value, id) => {
    setActivitiLogFilter({
      ...activitiLogFilterValue,
      [id]: value
    })
    tableProps.actions.setPage(1)
    requestActivitiLogDictinory()
  }

  const onRowSelect = (value) => {
    if (!value) {
      return 
    }
    setSelectedRow(value)
    setShowDetails(true)
  }

  const renderTree = useMemo(
    () => {
    const newTenants = tenantStructure.map((tenant) => {
      if (tenant.id === selectedTenant.id) {
        const newChildren = tenant.children
          .filter((element) => (element.type && element.name) || element.isFake)
        return {
          ...selectedTenant,
          ...tenant,
          loading: false,
          children: [
            ...newChildren,
          ],
        }
      }
      return tenant
    })
    return (
      <PageSidebar
          userTree
          title={<Lang id="menu.activityLog" />}
          content={(
            <>
              {newTenants.map(((tenant) => (
                <ViewTree
                  key={JSON.stringify(tenant)}
                  treeData={tenant}
                  searchQuery={search}
                  onSelect={handleSelected}
                />
              )))}
              {/* {(type === TENANT) && Object.keys(selectedTenant).length && (
                <ViewTree
                  key={JSON.stringify(selectedTenant)}
                  treeData={selectedTenant}
                  searchQuery={search}
                />
              )} */}
            </>
            )}
          headerContent={(
            <Lang id="usersPage.titles.search">
              {(placeholder) => (
                <TextControl
                  dark
                  placeholder={placeholder}
                  name="search"
                  icon={UsersIcons.MagnifierIcon}
                  onChange={handleChange}
                  value={search}
                  resetButton
                  resetField={resetSearch}
                />
              )}
            </Lang>
          )}
        />
    )
  },[tenantStructure, handleSelected, search, handleChange, selectedTenant])
  return (
    <Main>
      <Content>
        {renderTree}
        <DutyTable
          {...tableProps}
          withDates
          dates={dates}
          fields={fields}
          getTableData={setDatesRange}
          exportOptions={exportOptions}
          onFileSelect={requestFile}
          data={tableData}
          setEventTypes={setEventTypes}
          setStatusTypes={setStatusTypes}
          requestAlarmManagerTable={requestAlarmManagerTable}
          isDataLoading={loading}
          fieldOptions={isEmpty(filterDictinories) ? dictionaries : filterDictinories}
          descriptions={activitiLogFilterValue}
          handleFilterColumn={handleFilterColumn}
          onUpdateData={requestActionLogTable}
          rowSelector={onRowSelect}
          formatDate={'dd.MM.yyyy HH:mm'}
          showTimeSelect
          formatWithTime
        />
        {showDetails && 
          <ContainerDetails>
            <HeaderDetails>
              <TitleDetails>
                {selectedRow.fullName}
              </TitleDetails>
              <PortalTooltip
                title={<Lang id="buttons.close" />}
                handleIconClick={() => {}}
                renderChildren={(
                  wrapperRef,
                  onMouseEnterHandler,
                  onMouseLeaveHandler,
                  onClickHandler
                ) => (
                  <IconWrapper
                    onClick={onClickHandler}
                    ref={wrapperRef}
                    onMouseEnter={onMouseEnterHandler}
                    onMouseLeave={onMouseLeaveHandler}
                  >
                    <IconContainer onClick={()=> setShowDetails(false)}>
                      <HeaderIcons.MenuCloseIcon />
                    </IconContainer>
                  </IconWrapper>
                )}
              />
            </HeaderDetails>
            <ContentDeatils>
                {
                  Object.keys(detailsConfig).map((key) => (
                    <RowDetails key={key}>
                      <TitleRow>{detailsConfig[key]}</TitleRow>
                      <ValueRow>{selectedRow[key] || '-'}</ValueRow>
                    </RowDetails>
                  ))
                }
            </ContentDeatils>
          </ContainerDetails>
        }
      </Content>
    </Main>
  )
}

AlarmsManager.propTypes = {
  data: pt.arrayOf(pt.object),

  setSelectedElement: pt.func,
  setEventTypes: pt.func,
  setStatusTypes: pt.func,
  requestAlarmManagerTable: pt.func,
  requestAlarmManagerFile: pt.func,
}
AlarmsManager.defaultProps = {
  data: [],

  setSelectedElement: noop,
  setEventTypes: noop,
  setStatusTypes: noop,
  requestAlarmManagerTable: noop,
  requestAlarmManagerFile: noop,
}

export default AlarmsManager
